(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-product-root]').forEach((root) => {
  if (root.dataset.productReady === 'true') return
  root.dataset.productReady = 'true'

  const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent)
  const selectors = Array.from(root.querySelectorAll('[data-option-index]'))
  const variantInput = root.querySelector('[data-variant-id]')
  const price = root.querySelector('[data-product-price]')
  const submit = root.querySelector('[data-product-submit]')
  const status = root.querySelector('[data-product-status]')
  const slides = Array.from(root.querySelectorAll('[data-media-id]'))
  const label = root.querySelector('[data-carousel-label]')
  const count = root.querySelector('[data-carousel-count]')
  let activeSlide = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')))

  const showSlide = (index) => {
    if (!slides.length) return
    activeSlide = (index + slides.length) % slides.length
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeSlide
      slide.hidden = !active
      slide.classList.toggle('is-active', active)
    })
    label.textContent = slides[activeSlide].dataset.color || 'Colorway'
    count.textContent = String(activeSlide + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0')
  }

  const selectVariant = (changedIndex) => {
    const selected = selectors.map((selector) => selector.value)
    let variant = variants.find((item) => item.available && item.options.every((value, index) => value === selected[index]))

    if (!variant) {
      variant = variants.find((item) => item.available && item.options[changedIndex] === selected[changedIndex])
      if (variant) selectors.forEach((selector, index) => { selector.value = variant.options[index] })
    }

    if (!variant) {
      status.textContent = 'This combination is unavailable.'
      submit.disabled = true
      submit.textContent = 'SOLD OUT'
      return
    }

    status.textContent = ''
    variantInput.value = String(variant.id)
    price.textContent = variant.price
    submit.disabled = false
    submit.textContent = 'ADD TO CART'

    const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(variant.mediaId))
    if (mediaIndex >= 0) showSlide(mediaIndex)

    const nextUrl = new URL(window.location.href)
    nextUrl.searchParams.set('variant', variant.id)
    window.history.replaceState({}, '', nextUrl)
  }

  selectors.forEach((selector) => {
    selector.addEventListener('change', () => selectVariant(Number(selector.dataset.optionIndex)))
  })

  root.querySelector('[data-carousel-previous]')?.addEventListener('click', () => showSlide(activeSlide - 1))
  root.querySelector('[data-carousel-next]')?.addEventListener('click', () => showSlide(activeSlide + 1))
  selectVariant(0)
})

  } catch(e) { console.error(e); }
})();
})();
